import { Component, type ReactNode } from "react";
import { Button } from "@/presentation/components/Button";
import "./DrillErrorBoundary.css";

interface DrillErrorBoundaryProps {
  readonly children: ReactNode;
  /** `key` を変えて再マウントさせるための、やり直しボタン押下時のコールバック。 */
  readonly onRetry: () => void;
}

interface DrillErrorBoundaryState {
  readonly hasError: boolean;
}

/**
 * 演習単位のError Boundary（E-5）。エンジン例外は稽古の札の中で復旧し、段からは出さない。
 * `Board`/`TargetPanel`等の描画中に投げられた例外だけを捕まえ、段全体を巻き込まない。
 */
export class DrillErrorBoundary extends Component<
  DrillErrorBoundaryProps,
  DrillErrorBoundaryState
> {
  override state: DrillErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): DrillErrorBoundaryState {
    return { hasError: true };
  }

  private readonly handleRetry = (): void => {
    this.setState({ hasError: false });
    this.props.onRetry();
  };

  override render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div className="drill-error-boundary" role="alert">
          <p>この稽古がうまく進みませんでした。</p>
          <Button variant="secondary" onClick={this.handleRetry}>
            この稽古をやり直す
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}
